export default {
  highlightCardInfo: {
    titleLeftLabel: 'Comment ça marche ?',
    titleHighlightLabel: 'La gestion du patrimoine d’un mineur',
    contentLabel:
      "Les fonds placés au nom d'un mineur lui appartiennent et les administrateurs légaux doivent en assurer une gestion prudente jusqu'à sa majorité. En application des articles 385 et 386 du Code civil, l'administrateur légal est tenu d'apporter dans la gestion des biens du mineur des soins prudents, diligents et avisés, dans le seul intérêt du mineur sauf à engager sa responsabilité.",
  }
}
